import React, { useEffect, useState } from 'react';
import style from './TurbineManagementFormulary.module.scss';
import { FullscreenModal } from '../../../common/fullscreenModal/FullscreenModal';
import {
  ButtonPrimary,
  DataTable,
  Input,
  Loader,
  ModalContent,
  ModalHeader,
  SelectInputSearch,
} from '@skf/bt-wind-rail-commonlibrary';
import { useTranslation } from 'react-i18next';
import {
  BearingToPost,
  TaxonomyAssetInfoAdmin,
  TaxonomyAssetNameBearings,
  TaxonomyBearingInfoAdmin,
  TaxonomyCustomerAdmin,
  TaxonomySystemInfoAdmin,
  TaxonomySystemInfoAdminCompleted,
} from '../../../../store/taxonomy/types';
import { IOption } from '@skf/bt-wind-rail-commonlibrary/dist/components/form/types';
import { useDispatch, useSelector } from 'react-redux';
import {  
  getBearingParts,
  getBearings,
  ModifyBearings,
  PostBearings,
} from '../../../../store/taxonomy/actions';
import { StoreState } from '../../../../store/store';
import { ITaxonomyState } from '../../../../store/taxonomy/store';
import { useToast } from '../../../../hooks/useToast';

interface IBearingManagementFormularyProps {
  taxonomy?: TaxonomySystemInfoAdmin;
  turbines?: TaxonomySystemInfoAdminCompleted[];
  windfarms?: TaxonomyCustomerAdmin[];
  assets?: TaxonomyAssetInfoAdmin[];
  bearings?: TaxonomyAssetNameBearings[];
  onClose: () => void;
}

export const TurbineManagementFormularyBearings: React.FunctionComponent<IBearingManagementFormularyProps> = ({
  taxonomy,
  turbines,
  windfarms,
  assets,
  onClose,
}) => {
  const { addToast } = useToast();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const borderOk = { border: `1px solid #c7cad0` };
  const borderError = { border: `1px solid red` };
  const [isFetching] = useState<boolean>(false);
  const [_windfarmsOptions, _setWindfarmsOptions] = useState<IOption[]>([]);
  const [_windfarmValue, _setWindfarmValue] = useState<string>('');
  const [_windfarmDisabled, _setWindfarmDisabled] = useState<boolean>(false);
  const [_turbinesOptions, _setTurbinesOptions] = useState<IOption[]>([]);
  const [_turbineValue, _setTurbinesValue] = useState<string>('');
  const [_turbinesDisabled, _setTurbinesDisabled] = useState<boolean>(true);
  const [_assetsOptions, _setAssetsOptions] = useState<IOption[]>([]);
  const [_assetsValue, _setAssetsValue] = useState<string>('');
  const [_assetsDisabled, _setAssetsDisabled] = useState<boolean>(false);
  const [_assetSelected, _setAssetSelected] = useState<
  TaxonomyAssetInfoAdmin
  >();

  const [_positionsOptions, _setPositionsOptions] = useState<IOption[]>([]);
  const [_positionsValue, _setPositionsValue] = useState<string>('');
  const [_positionsDisabled, _setPositionsDisabled] = useState<boolean>(false);
  const [_bearingID, _setBearingID] = useState<string>('');
  const [_bearingIdBoolValidation, _setBearingIdBoolValidation] = useState(
    borderOk
  );
  const [_partName, _setPartName] = useState<string>('');
  const [_partNameBoolValidation, _setPartNameBoolValidation] = useState(
    borderOk
  );
  const [_partManufacturer, _setPartManufacturer] = useState<string>('');
  const [
    _partManufacturerBoolValidation,
    _setPartManufacturerBoolValidation,
  ] = useState(borderOk);

  const [_oemPartIdentification, _setOemPartIdentification] = useState<string>(
    ''
  );
  const [
    _oemPartIdentificationBoolValidation,
    _setOemPartIdentificationBoolValidation,
  ] = useState(borderOk);

  const [_oemPartDescription, _setOemPartDescription] = useState<string>('');
  const [
    _oemPartDescriptionBoolValidation,
    _setOemPartDescriptionBoolValidation,
  ] = useState(borderOk);
  const [
    _customerPartIdentification,
    _setCustomerPartIdentification,
  ] = useState<string>('');
  const [
    _customerPartIdentificationBoolValidation,
    _setCustomerPartIdentificationBoolValidation,
  ] = useState(borderOk);

  const [_customerPartDescription, _setCustomerPartDescription] = useState<
    string
  >('');
  const [
    _customerPartDescriptionBoolValidation,
    _setCustomerPartDescriptionBoolValidation,
  ] = useState(borderOk);
  const [
    _othersProductIdentification,
    _setOthersProductIdentification,
  ] = useState<string>('');
  const [
    _othersProductIdentificationBoolValidation,
    _setOthersProductIdentificationBoolValidation,
  ] = useState(borderOk);
  const [_skfProductGroup, _setSkfProductGroup] = useState<string>('');
  const [
    _skfProductGroupBoolValidation,
    _setSkfProductGroupBoolValidation,
  ] = useState(borderOk);
  const [_skfProductId, _setSkfProductId] = useState<string>('');
  const [
    _skfProductIdBoolValidation,
    _setSkfProductIdBoolValidation,
  ] = useState(borderOk);
  const [_installDate, _setInstallDate] = useState<Date | string>();
  const [_bearingsList, _setBearingsList] = useState<
    TaxonomyBearingInfoAdmin[]
  >([]);
  const [_positionFromManagement, _setPositionFromManagement] = useState<
    string
  >('');
  const { taxonomyAssets } = useSelector<StoreState, ITaxonomyState>(
    (selector) => selector.taxonomyAddAssetInfo
  );
  const { bearingPositions } = useSelector<StoreState, ITaxonomyState>(
    (selector) => selector.bearingPositions
  );
  const [_bearingsToPost, _setBearingsToPost] = useState<BearingToPost[]>([]);
  const [_inputValInstallDate, _setInputValInstallDate] = useState(borderOk);
  const [_windfarmInputVal, _setWindfarmInputVal] = useState<string>(
    style.correctInput
  );
  const [_turbineInputVal, _setTurbineInputVal] = useState<string>(
    style.correctInput
  );
  const [_assetInputVal, _setAssetInputVal] = useState<string>(
    style.correctInput
  );
  const [_positionInputVal, _setPositionInputVal] = useState<string>(
    style.correctInput
  );

  useEffect(() => {
    if (taxonomy) {
      _setWindfarmDisabled(true);
      _setTurbinesDisabled(true);
      _setAssetsDisabled(true);
      _setPositionsDisabled(true);
    } else {
      _setAssetsDisabled(true);
      _setPositionsDisabled(true);
    }
  }, [taxonomy]);

  useEffect(() => {
    if (taxonomy && windfarms && turbines && assets) {
      const asset = assets.find((x) => x.assetKey === taxonomy.assetKey);
      const turbine = turbines.find(
        (x) => x.sectionSystemKey === asset?.sectionSystemKey
      );
      const windfarm = windfarms.find(
        (x) => x.plantUnitKey === turbine?.plantUnitKey
      );

      if (asset && turbine && windfarm) {
        _setWindfarmValue(windfarm.plantUnitKey);
        _setWindfarmsOptions([
          {
            label: windfarm.plantUnitDescription
              ? windfarm.plantUnitDescription
              : '',
            value: windfarm.plantUnitKey,
            labelToShow: windfarm.plantUnitDescription
              ? windfarm.plantUnitDescription
              : '',
          },
        ]);

        _setTurbinesValue(turbine.sectionSystemId);
        _setTurbinesOptions([
          {
            label: turbine.sectionSystemId,
            value: turbine.sectionSystemId,
            labelToShow: turbine.sectionSystemId,
          },
        ]);

        _setAssetsValue(asset.assetId);
        _setAssetSelected(asset);
        _setAssetsOptions([
          {
            label: asset.assetId,
            value: asset.assetId,
            labelToShow: asset.assetId,
          },
        ]);
      }

      _setPositionFromManagement(taxonomy.position ? taxonomy.position : '');
      _setBearingID(taxonomy.partId ? taxonomy.partId : '');
      _setPartName(taxonomy.partName ? taxonomy.partName : '');
      _setPartManufacturer(
        taxonomy.partManufacturer ? taxonomy.partManufacturer : ''
      );
      _setOemPartIdentification(
        taxonomy.oemPartCode ? taxonomy.oemPartCode : ''
      );
      _setOemPartDescription(
        taxonomy.oemPartDescription ? taxonomy.oemPartDescription : ''
      );
      _setCustomerPartIdentification(
        taxonomy.customerPartCode ? taxonomy.customerPartCode : ''
      );
      _setCustomerPartDescription(
        taxonomy.customerPartDescription ? taxonomy.customerPartDescription : ''
      );
      _setSkfProductGroup(
        taxonomy.skfProductGroup ? taxonomy.skfProductGroup : ''
      );
      _setSkfProductId(taxonomy.skfPartCode ? taxonomy.skfPartCode : '');
      _setOthersProductIdentification(
        taxonomy.competitorProductIdentification
          ? taxonomy.competitorProductIdentification
          : ''
      );

      if (taxonomy.installedDate && taxonomy.installedDate !== '') {
        // TODO: Check if we can do this with moment.js
        const d = new Date(taxonomy.installedDate);
        let year = d.getFullYear().toString();
        if (parseInt(year) < 1000) {
          year = `000${year}`;
        }
        let month = (d.getMonth() + 1).toString();
        if (Number(month) < 10) month = '0' + month;
        let day = d.getDate().toString();
        if (Number(day) < 10) day = '0' + day;
        _setInstallDate(year + '-' + month + '-' + day);
      }
    }
  }, []);

  useEffect(() => {
    if (!taxonomy && windfarms) {
      let windOptions: IOption[] = [];
      windfarms.forEach((windfarm: TaxonomyCustomerAdmin) => {
        if (windfarm.plantUnitDescription) {
          windOptions.push({
            label: windfarm.plantUnitDescription,
            value: windfarm.plantUnitKey,
            labelToShow: windfarm.plantUnitDescription,
          });
        }
      });
      _setWindfarmsOptions(windOptions);
    }
  }, [windfarms, taxonomy]);

  useEffect(() => {
    if (taxonomyAssets && !taxonomy && _turbineValue) {
      const assetOptions: IOption[] = taxonomyAssets.map((x) => ({
        label: x.assetId,
        value: x.assetId,
        labelToShow: x.assetId,
      }));

      _setAssetsOptions(assetOptions);
      _setAssetsDisabled(false);
    }
  }, [taxonomyAssets, taxonomy, _turbineValue]);

  useEffect(() => {
    if (bearingPositions && _bearingsList && !taxonomy) {
      let positionOptions: IOption[] = [];
      let filtered: string[] = [];
      bearingPositions.forEach((x) => {
        const exits = _bearingsList.find((y) => y.position === x);
        if (!exits) {
          filtered.push(x);
          positionOptions.push({ label: x, value: x, labelToShow: x });
        }
      });
      if (positionOptions && positionOptions.length > 0) {
        _setPositionsOptions(positionOptions);
        _setPositionsDisabled(false);
      } else {
        _setPositionsOptions([]);
        _setPositionsDisabled(true);
      }
    }
  }, [bearingPositions, _bearingsList, taxonomy]);

  useEffect(() => {
    if (
      taxonomy &&
      _positionsOptions &&
      _positionFromManagement !== '' &&
      _positionsValue !== _positionFromManagement
    ) {
      if (_positionFromManagement !== '') {
        _setPositionsOptions([
          {
            label: _positionFromManagement,
            value: _positionFromManagement,
            labelToShow: _positionFromManagement,
          },
          ..._positionsOptions,
        ]);
        _setPositionsValue(_positionFromManagement);
      }
    }
  }, [_positionsOptions, _positionFromManagement]);

  useEffect(() => {
    if (_assetSelected) loadBearingList();
  }, [_assetSelected]);

  /********************************** DATA TABLE COLS AND OTHERS *************************/

  const columnsNEW: any[] = [
    {
      Header: t('position'),
      accessor: 'position',
    },
    {
      Header: t('bearing_ID'),
      accessor: 'partId',
    },
    {
      Header: t('part_Manufacturer'),
      accessor: 'partManufacturer',
    },
    {
      Header: t('OEM_Part_ID'),
      accessor: 'oemPartCode',
    },
    {
      Header: t('prod_designation'),
      accessor: 'skfPartCode',
    },
    {
      Header: t('Install_Date'),
      accessor: 'installedDate',
    },

    // {
    //   Header: '',
    //   accessor: 'Action',
    //   disableSortBy: true,

    //   Cell: ({ row: { original: { assetPartKey } } }: any) => {

    //     return (
    //       <div >

    //         <IconTrash
    //         //   onClick={() => deleteNewTurbine(sectionSystemId)}
    //             onClick={()=>RemoveBearingFromList(assetPartKey)}
    //           className={style.cursorPointer}
    //         />

    //       </div>
    //     );
    //   },
    // },
  ];

  /********************************** DATA TABLE COLS AND OTHERS *************************/

  const handleWindfarmSelected = (value: string) => {
    if (value !== _windfarmValue) {
      _setTurbinesDisabled(true);
      _setAssetsDisabled(true);
      _setPositionsDisabled(true);
      _setAssetsValue('');
      _setPositionsValue('');
      _setTurbinesValue('');
      _setWindfarmValue(value);

      if (value === '') return;
    }

    if (windfarms && turbines) {
      let turbOptions: IOption[] = turbines
        .filter((x) => x.plantUnitKey === value)
        .map((x) => ({
          label: x.sectionSystemId,
          value: x.sectionSystemId,
          labelToShow: x.sectionSystemId,
        }));
      _setTurbinesOptions(turbOptions);
      _setTurbinesDisabled(false);
    }
  };

  const handleSelectTurbine = (value: string) => {
    if (windfarms && _windfarmValue && turbines && !taxonomy) {
      if (value !== _turbineValue) {
        _setAssetsDisabled(true);
        _setPositionsDisabled(true);
        _setAssetsValue('');
        _setPositionsValue('');
        _setTurbinesValue(value);
        _setBearingsList([]);

        if (value === '') return;
      }

      const wind = windfarms.find((x) => x.plantUnitKey === _windfarmValue);
      const turb = turbines.find((x) => x.sectionSystemId === value);
      dispatch(getBearings(wind?.plantUnitKey, turb?.sectionSystemKey));
    }
  };

  const handleOnAssetSelected = (value: string) => {
    if (value !== _assetsValue) {
      _setPositionsDisabled(true);
      _setPositionsValue('');
      _setAssetsValue(value);
      _setBearingsList([]);
      _setAssetSelected(undefined);

      if (value === '') return;
    }

    const assetSelected = taxonomyAssets?.find((x) => x.assetId === value);

    if (assetSelected) {
      dispatch(getBearingParts(assetSelected.assetClaseCode));
      _setAssetSelected(assetSelected);
    }
  };

  const loadBearingList = () => {
    if (_assetSelected) {
      const bearingsListNew: TaxonomyBearingInfoAdmin[] = _assetSelected.taxonomiesPart.map(
        (x: TaxonomyBearingInfoAdmin) => x
      );
      _setBearingsList(bearingsListNew);
    }
  };

  const addNewBearingToList = () => {
    if (validate()) {
      let year: number = 0;
      let month: number = 0;
      let day: number = 0;

      if (_installDate) {
        const d = new Date(_installDate);
        year = d.getFullYear();
        month = d.getMonth();
        day = d.getDate();
      }
      let newBearing: TaxonomyBearingInfoAdmin = {
        position: _positionsValue,
        partId: _bearingID,
        partName: _partName,
        partManufacturer: _partManufacturer,
        oemPartCode: _oemPartIdentification,
        oemPartDescription: _oemPartDescription,
        customerPartCode: _customerPartIdentification,
        customerPartDescription: _customerPartDescription,
        competitorProductIdentification: _othersProductIdentification,
        skfProductGroup: _skfProductGroup,
        skfPartCode: _skfProductId,
        installedDate: year + '-' + month + '-' + day + 'T00:00:00',
        assetId: _assetSelected?.assetId,
        assetPartKey: _assetSelected ? _assetSelected.assetKey : '',
        partSerialNumber: '',
        functionalLocationDescription: '',
        functionalLocationId: '',
        partManufacturingDate: '',
        partManufacturingSite: '',
      };
      let newBearingToPost: BearingToPost = {
        position: _positionsValue,
        partId: _bearingID,
        partName: _partName,
        partManufacturer: _partManufacturer,
        oemPartCode: _oemPartIdentification,
        oemPartDescription: _oemPartDescription,
        customerPartCode: _customerPartIdentification,
        customerPartDescription: _customerPartDescription,
        competitorProductIdentification: _othersProductIdentification,
        skfProductGroup: _skfProductGroup,
        skfPartCode: _skfProductId,
        installedDate: new Date(year, month, day),
        AssetKey: _assetSelected ? _assetSelected.assetKey : '',
        assetPartKey: '',
        plantUnitKey: _windfarmValue,
      };

      _setBearingsToPost([..._bearingsToPost, newBearingToPost]);
      _setBearingsList([newBearing, ..._bearingsList]);
      const bearingPartOptions: IOption[] = _positionsOptions.filter(
        (x: IOption) => x.value !== newBearing.position
      );
      _setPositionsOptions(bearingPartOptions);
      _setPositionsValue('');
    }
  };

  const handleSendData = () => {
    const addBearingsError = () => {
      addToast({
        status: 'danger',
        message: t('failedAddBearing'),
        timeout: 7000,
      });
    };
    const addBearingsProgress = () => {
      addToast({
        status: 'warning',
        message: t('addBearing'),
        timeout: 7000,
      });
    };
    const addBearingsOk = () => {
      addToast({
        status: 'ok',
        message: t('addBearingOk'),
        timeout: 7000,
      });
    };
    dispatch(
      PostBearings(
        _bearingsToPost,
        addBearingsOk,
        addBearingsProgress,
        addBearingsError
      )
    );
    onClose();
  };

  const handleSendDataModify = () => {
    if (validate()) {
      let year: number = 0;
      let month: number = 0;
      let day: number = 0;
      if (_installDate) {
        const d = new Date(_installDate);
        year = d.getFullYear();
        month = d.getMonth();
        day = d.getDate();
      }
      let assetPartKey = '';
      if (assets) {
        const a = assets.find((x) => x.assetId === taxonomy?.assetId);
        const q = a?.taxonomiesPart.find(
          (x) => x.position === taxonomy?.position
        );
        if (q) {
          assetPartKey = q.assetPartKey;
        }
      }
      let newBearingToPut: BearingToPost = {
        position: _positionsValue,
        partId: _bearingID,
        partName: _partName,
        partManufacturer: _partManufacturer,
        oemPartCode: _oemPartIdentification,
        oemPartDescription: _oemPartDescription,
        customerPartCode: _customerPartIdentification,
        customerPartDescription: _customerPartDescription,
        competitorProductIdentification: _othersProductIdentification,
        skfProductGroup: _skfProductGroup,
        skfPartCode: _skfProductId,
        installedDate: new Date(year, month, day),
        AssetKey: _assetSelected ? _assetSelected.assetKey : '',
        assetPartKey: assetPartKey,
        plantUnitKey: _windfarmValue,
      };
      const toastrBearingId = newBearingToPut.partId || '';
      const updateBearingsOk = () => {
        addToast({
          status: 'ok',
          message: t('modifyBearingOk'),
          timeout: 7000,
        });
      };
      const updateBearingsProgress = () => {
        addToast({
          status: 'warning',
          message: t('modifyBearing').replace('@', toastrBearingId),
          timeout: 7000,
        });
      };
      const updateBearingsFailed = () => {
        addToast({
          status: 'danger',
          message: t('failedUpdateBearing').replace('@', toastrBearingId),
          timeout: 7000,
        });
      };
      dispatch(
        ModifyBearings(
          newBearingToPut,
          updateBearingsOk,
          updateBearingsProgress,
          updateBearingsFailed
        )
      );
      onClose();
    }
  };

  const validate = () => {
    let toReturn = true;
    /*****************************************************************/
    // if(!_bearingID || _bearingID === ''){
    //     _setBearingIdBoolValidation(borderError);
    //     toReturn = false;
    // }else{
    //     _setBearingIdBoolValidation(borderOk);
    // }
    // if(!_partName || _partName === ''){
    //     _setPartNameBoolValidation(borderError);
    //     toReturn = false;
    // }else{
    //     _setPartNameBoolValidation(borderOk);
    // }
    // /*****************************************************************/
    // if(!_partManufacturer || _partManufacturer === ''){
    //     _setPartManufacturerBoolValidation(borderError);
    //     toReturn = false;
    // }else{
    //     _setPartManufacturerBoolValidation(borderOk);
    // }
    // if(!_oemPartIdentification || _oemPartIdentification === ''){
    //     _setOemPartIdentificationBoolValidation(borderError);
    //     toReturn = false;
    // }else{
    //     _setOemPartIdentificationBoolValidation(borderOk);
    // }
    // if(!_oemPartDescription || _oemPartDescription === ''){
    //     _setOemPartDescriptionBoolValidation(borderError);
    //     toReturn = false;
    // }else{
    //     _setOemPartDescriptionBoolValidation(borderOk);
    // }
    // /*****************************************************************/
    // if(!_customerPartIdentification || _customerPartIdentification === ''){
    //     _setCustomerPartIdentificationBoolValidation(borderError);
    //     toReturn = false;
    // }else{
    //     _setCustomerPartIdentificationBoolValidation(borderOk);
    // }
    // if(!_customerPartDescription || _customerPartDescription === ''){
    //     _setCustomerPartDescriptionBoolValidation(borderError);
    //     toReturn = false;
    // }else{
    //     _setCustomerPartDescriptionBoolValidation(borderOk);
    // }
    // if(!_othersProductIdentification || _othersProductIdentification === ''){
    //     _setOthersProductIdentificationBoolValidation(borderError);
    //     toReturn = false;
    // }else{
    //     _setOthersProductIdentificationBoolValidation(borderOk);
    // }
    // /*****************************************************************/
    // if(!_skfProductGroup || _skfProductGroup === ''){
    //     _setSkfProductGroupBoolValidation(borderError);
    //     toReturn = false;
    // }else{
    //     _setSkfProductGroupBoolValidation(borderOk);
    // }
    // if(!_skfProductId || _skfProductId === ''){
    //     _setSkfProductIdBoolValidation(borderError);
    //     toReturn = false;
    // }else{
    //     _setSkfProductIdBoolValidation(borderOk);
    // }
    /*****************************************************************/

    if (!_windfarmValue) {
      _setWindfarmInputVal(style.errorInput);
      toReturn = false;
    } else {
      _setWindfarmInputVal(style.correctInput);
    }
    if (!_turbineValue) {
      _setTurbineInputVal(style.errorInput);
      toReturn = false;
    } else {
      _setTurbineInputVal(style.correctInput);
    }
    if (!_assetsValue) {
      _setAssetInputVal(style.errorInput);
      toReturn = false;
    } else {
      _setAssetInputVal(style.correctInput);
    }
    if (!_positionsValue) {
      _setPositionInputVal(style.errorInput);
      toReturn = false;
    } else {
      _setPositionInputVal(style.correctInput);
    }

    if (!_installDate || _installDate === undefined) {
      _setInputValInstallDate(borderError);
      toReturn = false;
    } else {
      _setInputValInstallDate(borderOk);
    }

    if (toReturn === false) {
      addToast({
        status: 'warning',
        message: t('Complete al required inputs'),
      });
    }
    return toReturn;
  };

  return (
    <>
      <FullscreenModal onClose={onClose} className={style.modal}>
        <ModalHeader onClose={onClose}>
          {!taxonomy ? t('Add_Bearings') : t('Modify_Bearing')}
        </ModalHeader>
        <ModalContent className={style.content}>
          <Loader center show={isFetching} className={style.loader} />
          <section className={style.content}>
            <div className={style.conatinerthreColums}>
              <SelectInputSearch
                className={_windfarmInputVal}
                isDisabled={_windfarmDisabled}
                placeHolder={t('select_windfarm')}
                value={_windfarmValue}
                options={_windfarmsOptions}
                onSelectedItemChanged={(e) => {
                  handleWindfarmSelected(e ? e.value.toString() : '');
                }}
              />
              <SelectInputSearch
                className={_turbineInputVal}
                isDisabled={_turbinesDisabled}
                placeHolder={t('select_turbine')}
                value={_turbineValue}
                options={_turbinesOptions}
                onSelectedItemChanged={(e) =>
                  handleSelectTurbine(e ? e.value.toString() : '')
                }
              />
              <SelectInputSearch
                className={_assetInputVal}
                isDisabled={_assetsDisabled}
                placeHolder={t('select_asset')}
                value={_assetsValue}
                options={_assetsOptions}
                onSelectedItemChanged={(e) =>
                  handleOnAssetSelected(e ? e.value.toString() : '')
                }
              />
            </div>
          </section>
          <section className={style.content}>
            <div className={style.conatinerfourColums}>
              <SelectInputSearch
                className={_positionInputVal}
                isDisabled={_positionsDisabled}
                placeHolder={t('select_position')}
                value={_positionsValue}
                options={_positionsOptions}
                onSelectedItemChanged={(e) => {
                  _setPositionsValue(e ? e.value.toString() : '');
                }}
              />
              <Input
                style={_bearingIdBoolValidation}
                placeholder={t('bearing_id')}
                value={_bearingID}
                maxLength={100}
                onChange={(e) => {
                  _setBearingID(e);
                  _setBearingIdBoolValidation(borderOk);
                }}
              />
              <Input
                style={_partNameBoolValidation}
                placeholder={t('bearing_part_name')}
                value={_partName}
                maxLength={40}
                onChange={(e) => {
                  _setPartName(e);
                  _setPartNameBoolValidation(borderOk);
                }}
              />
              {taxonomy ? (
                <div></div>
              ) : (
                <ButtonPrimary outline onClick={addNewBearingToList}>
                  {t('Add_Bearing')}
                </ButtonPrimary>
              )}
            </div>
            <div className={style.conatinerfourColums}>
              <Input
                style={_partManufacturerBoolValidation}
                placeholder={t('bearing_part_manufacturer')}
                value={_partManufacturer}
                maxLength={40}
                onChange={(e) => {
                  _setPartManufacturer(e);
                  _setPartManufacturerBoolValidation(borderOk);
                }}
              />
              <Input
                style={_oemPartIdentificationBoolValidation}
                placeholder={t('bearing_oem_part_identification')}
                value={_oemPartIdentification}
                maxLength={20}
                onChange={(e) => {
                  _setOemPartIdentification(e);
                  _setOemPartIdentificationBoolValidation(borderOk);
                }}
              />
              <Input
                style={_oemPartDescriptionBoolValidation}
                placeholder={t('bearing_oem_part_description')}
                value={_oemPartDescription}
                maxLength={60}
                onChange={(e) => {
                  _setOemPartDescription(e);
                  _setOemPartDescriptionBoolValidation(borderOk);
                }}
              />
              <div></div>
            </div>
            <div className={style.conatinerfourColums}>
              <Input
                style={_customerPartIdentificationBoolValidation}
                placeholder={t('bearing_customer_part_identification')}
                value={_customerPartIdentification}
                maxLength={20}
                onChange={(e) => {
                  _setCustomerPartIdentification(e);
                  _setCustomerPartIdentificationBoolValidation(borderOk);
                }}
              />
              <Input
                style={_customerPartDescriptionBoolValidation}
                placeholder={t('bearing_customer_part_description')}
                value={_customerPartDescription}
                maxLength={60}
                onChange={(e) => {
                  _setCustomerPartDescription(e);
                  _setCustomerPartDescriptionBoolValidation(borderOk);
                }}
              />
              <Input
                style={_othersProductIdentificationBoolValidation}
                placeholder={t('bearing_other_product_identification')}
                value={_othersProductIdentification}
                maxLength={40}
                onChange={(e) => {
                  _setOthersProductIdentification(e);
                  _setOthersProductIdentificationBoolValidation(borderOk);
                }}
              />
              <div></div>
            </div>
            <div className={style.conatinerfourColums}>
              <Input
                style={_skfProductGroupBoolValidation}
                placeholder={t('bearing_skf_product_group')}
                value={_skfProductGroup}
                maxLength={40}
                onChange={(e) => {
                  _setSkfProductGroup(e);
                  _setSkfProductGroupBoolValidation(borderOk);
                }}
              />
              <Input
                style={_skfProductIdBoolValidation}
                placeholder={t('bearing_skf_product_id')}
                value={_skfProductId}
                maxLength={80}
                onChange={(e) => {
                  _setSkfProductId(e);
                  _setSkfProductIdBoolValidation(borderOk);
                }}
              />
              <Input
                style={_inputValInstallDate}
                value={_installDate}
                type={'date'}
                placeholder={t('Install date')}
                onChange={(e) => {
                  _setInstallDate(e);
                  _setInputValInstallDate(borderOk);
                }}
              />
              <div></div>
            </div>
          </section>
          {_bearingsList.length > 0 && (
            <section>
              <DataTable
                columns={assets ? columnsNEW : columnsNEW} // TODO: WTF is this?
                data={assets ? _bearingsList : _bearingsList}
                className={style.table}
                pagination={5}
              />
            </section>
          )}
          <div className={style.navigation}>
            <ButtonPrimary onClick={onClose} outline>
              {t('Cancel')}
            </ButtonPrimary>
            <ButtonPrimary
              outline
              onClick={taxonomy ? handleSendDataModify : handleSendData}
            >
              {taxonomy ? t('modify') : t('Save')}
            </ButtonPrimary>
          </div>
        </ModalContent>
      </FullscreenModal>
    </>
  );
};
